<template>
  <main>
    <div>
      <h3>{{preset}} {{mode}} 反馈 和 图像</h3>
      <el-input type="textarea" v-model="reviewData.opinion" maxlength="256" show-word-limit rows="10"></el-input>
      <el-upload class="upload-demo" action="https://remoteserver.storkhealthcare.cn/releaseReview/uploadImageForReleaseReview"
        :on-remove="handleRemove" :before-remove="beforeRemove" :on-success="handleSuccess" :limit="3"
        :on-exceed="handleExceed" :file-list="reviewData.fileList" list-type="picture" drag>
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>
      </el-upload>
    </div>
    <el-divider></el-divider>
  </main>
</template>

<script>
  import Global from '../Global.vue';

  export default {
    name: 'ReleaseReviewItem',
    props: ['preset', 'mode'],
    data() {
      return {
        reviewData: {
          // 上传的意见
          opinion: '',
          // 上传的图片列表
          fileList: []
        }
      }
    },
    watch: {
      'reviewData.fileList'() {
        this.sendReviewData();
      },
      'reviewData.opinion'() {
        this.sendReviewData();
      }
    },
    methods: {
      // 输入框内容改变的时候发送给父组件
      sendReviewData() {
        this.$emit('getReviewData', this.reviewData);
      },
      // 当上传文件超出指定个数的时候调用这个函数
      handleExceed(file, fileList) {
        this.$message.warning('每个条目最多上传3个图片');
      },
      // 文件列表移除某个文件时候回调这个函数
      handleRemove(file, fileList) {
        // 在fileList中删除这个文件
        fileList.forEach((value, index, fileList) => {
          if (value.name == file.name) {
            fileList.slice(index);
          }
        });
        this.reviewData.fileList = fileList;
        // 在服务器中删除这个文件
        let that = this;
        that.axios({
          method: 'POST',
          url: Global.accountUrl + '/releaseReview/deleteImageForReleaseReview?url=' + file.url  
        }).then(function(response) {
          if(response.data.code != 200) {
            that.$message.error(response.data.data);
          } 
        });
      },
      // 上传图片成功以后调用这个函数
      handleSuccess(res, file) {
        // 在fileList中添加这个文件
        if (res.code == 200) {
          this.reviewData.fileList.push(res.data);
        } else {
          this.$message.error(res.data);
        }
      },
      // 当文件被移除之前调用这个函数
      beforeRemove(file, fileList) {
        return this.$confirm(`确定移除 ${ file.name }？`);
      }
    },
  }

</script>

<style scoped>
  div {
    max-width: 600px;
    margin: 25px auto;
  }

  .upload-demo {
    text-align: center;
  }

  h3 {
    text-align: center;
  }

</style>



// WEBPACK FOOTER //
// src/components/release_review/ReleaseReviewItem.vue